import { SerializedFile } from "@repo/models";

export default interface Rep extends RepDocumentation {
	id: number;
	systemId: string;
	repId: number;
	isTest: boolean;
	firstName: string;
	middleName: string;
	lastName: string;
	statusEnum: RepStatusEnum;
	statusName: string;
	statusDetails: string;
	active: boolean;
	login: string;
	startDate: Date;
	repTypeId: number;
	isTrainer: boolean;
	position: string;
	positionId: number;
	managerId: number;
	managerName: string;
	trainerId: number;
	trainerName: string;
	lastFourSSN: string;
	dateOfBirth: Date;
	phone: string;
	email: string;
	brandId: number;
	brand: string;
	marketerId: number;
	vendor: string;
	stateId: number;
	state: string;
	channelId: number;
	channel: string;
	branchId: number;
	branchName: string;
	branchIsInactive: boolean;
	managerIsInactive: boolean;
	lastMachinePingName: string;
	lastMachinePingTimestamp: Date;
	deactivationDate?: Date;
	deactivationReason: string;
	effectiveDeactivationDate: Date;
	derivedDeactivationDate: Date;
	lastDisciplineName: string;
	lastDisciplineReason: string;
	lastDisciplineStartDate: Date;
	lastDisciplineEndDate: Date;
	defaultUtility: string;
	dateLastModified: Date;
	lastModifiedBy: string;
	languageId: number;
	language: string;
	pin: string;
	dlScanEnabled: boolean;
	eclEnabled: boolean;
	dlScanRequired: boolean;
	possibleBlacklist: boolean;

	photoUrl: string;
	photo?: SerializedFile;

	totalSales: number;
	totalGoodSales: number;
	totalNoSales: number;
	onboardingDate?: Date;
	dateLastSale?: Date;
	firstSaleMachineName: string;
	firstSaleDate?: Date;
	lastSaleMachineName: string;

	//Move to an options thing
	showInactiveOffices: boolean;
	showInactiveManagers: boolean;

	contingentExpirationDate?: Date;

	machineId?: number;
	attributes: Record<string, string>;
	mappedAttributes: Record<string, string | boolean>;
}

export interface RepDocumentation {
	DocumentationAffidavit: boolean;
	PerformanceStandardsAffidavit: boolean;
	PerformanceStandardsDocumentId: number;
	PerformanceStandardsDocument: SerializedFile;
}

export type RepProp = keyof Rep;

export enum RepStatusEnum {
	Onboarding = 1,
	AwaitingActivation = 2,
	ContingentStart = 3,
	Active = 4,
	Terminated = 5,
	Deactivated = 6,
	AwaitingContingentActivation = 7,
	OnHold = 8,
	AwaitingContingentApproval = 9,
	Suspended = 10,
}

export interface RepTypes {
	Name: string;
	RepTypeId: number;
}
